<template lang="pug">
  main
    NavBarSca
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h3.title Búsquedas TPA
        .columns.is-vcentered
          .column.is-3
            .field
              .control
                input.input.is-black(
                  type='text', 
                  placeholder='🔎 Buscar por PG',
                  v-model="search",
                )
          .column.is-3.is-1
            a.button.is-black.is-rounded.is-small(@click="buscarDocumentos")
              i.fas.fa-search
              | &nbsp Buscar
          .column.is-offset-3.is-3
            .field
              .control
                input.input.is-black(
                  type='text', 
                  placeholder='🔎 Filtrar',
                  v-model="filter",
                )
        .columns(v-show="documentos.length > 0")
          .column.is-12
            .table-responsive
              table#documentados.table.is-striped.is-fullwidth
                thead
                  tr
                    th.is-size-6
                      | Embarque
                    th.is-size-6 
                      | Autotanque
                    th.is-size-6 
                      | Registrado
                    th.is-size-6 
                      | Empresa
                    th.is-size-6 
                      | Grupo
                    th.is-size-6 
                      | Densidad Corr.
                tbody
                  tr(v-for="doc in documentosFilter" :key="doc.id")
                    td 
                      a.button.is-text {{ doc.numeroDeEmbarque }}
                      | &nbsp
                      a.button.is-black.is-rounded.is-small(@click="getLink(doc)")
                        span.icon
                          i.fas.fa-print
                    td {{ doc.pg }}
                    td {{ doc.fechaSalida }}
                    td(v-html="doc.companiaStr")
                    td(v-html="getGrupo(doc)")
                    td {{ doc.densidad}}
        .columns(v-show="documentos.length < 1")
          .column.is-12
            .notification
              |   No hay registros con éstos criterios de Búsqueda.
        .columns.column-blanco
</template>

<script>
  import NavBarSca from '@/components/sca_Componentes/layout/tpa/NavBarSca.vue'
  import Loader from '@/components/shared/Loader.vue'
  import sca_tuxpanServices from '@/services/sca/tpa.js'

  export default {
    name: 'Busquedas_TPA',
    components: { NavBarSca, Loader },
    data() {
      return {
        isLoading: true,
        search: '',
        documentos: [],
        documentosFilter: [],
        filter: '',
      }
    },
    watch: {
      filter() {
        if (this.documentos.length < 1) {
          return
        }
        this.documentosFilter = []
        const filterMayus = this.filter.toUpperCase()
        const embFilter = this.documentos.filter( emb => { 
          return `${emb.pg} ${emb.fechaSalida} ${emb.grupoStr} ${emb.subgrupoStr} ${emb.noEmbarque}`.toUpperCase().includes(filterMayus)
        }) 
        this.documentosFilter = embFilter
      }
    },
    methods: {
      iniciarComponente() {
        setTimeout(() => {
          this.isLoading = false
        }, 350)
      },

      buscarDocumentos() {
        this.isLoading = true
        sca_tuxpanServices.getDocumentados_pg(this.search)
          .then( data => {
            this.documentos = data
            this.documentosFilter = this.documentos
            this.isLoading = false
          })
          .catch( e => {
            this.isLoading = false
            console.log(e.message)
          })
      },

      getGrupo(emp) {
        let html = ''
        const { grupoStr, subgrupoStr } = emp
        if (grupoStr === subgrupoStr) {
          html = `<span class="tag is-black">${grupoStr}</span>`
        } else {
          html = `<div class="control">
            <div class="tags has-addons">
              <span class="tag is-dark">${grupoStr}</span>
              <span class="tag is-primary">${subgrupoStr}</span>
            </div>
          </div>`
        }
        return html
      },

      getLink (emb) {
        var currentUrl = window.location.hostname
        this.link = `https://${currentUrl}/servidores/reportes/cartaPorte_Tpa.php?emb=${emb.noEmbarque}&n=${emb.numeroDeEmbarque}` 
        window.open(this.link, '_blank')
      },
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>
.column-blanco {
  padding-bottom: 100px;
}
.is-top {
  margin-top: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/Busquedas_TPA.vue